import React, { useState, useEffect } from "react";
import { message, Upload,Tabs, Button,Divider ,InputNumber,Input,Checkbox,Select,notification,Col, Row} from "antd";
import { DeleteOutlined,SaveOutlined,ArrowRightOutlined,ArrowLeftOutlined} from "@ant-design/icons";
import "./History.scss";
import * as XLSX from 'xlsx';
import {deleteHD,} from "../../../api/user";
import {get} from "../../../api/get";
import {post} from "../../../api/post";
import TableFullEditable from "../../../components/table/tableFullEditable/TableFullEditable";


export default function HistoryData() {
  const { Option } = Select;
  const { Dragger } = Upload;

  const [datas, setdatas] = useState([]);
  const [dataTabla, setdataTabla] = useState([]);
  const [circular, setCircular] = useState(false);
  const [newdatos, setnewdatos] = useState([]);
  const [cambios, setcambios] = useState(false);

  useEffect(() => {
    // console.log('in')
    var vector=[]
    var DATA
    var checkboxAux={}
    get('history-data','history-data','').then((response) => {
    // getHistoryData().then((response) => {
      DATA = response.historyData;
      // console.log('Data: ',DATA);
      for (let i = 0; i < DATA.length; i++) {
        // console.log('Data: ',DATA[i]);
        let keys = Object.keys(DATA[i].data);
        let length = DATA[i].data[keys[0]].length;

        let newArray = Array.from({length}, (_, j) => 
          keys.reduce((acc, key) => ({...acc, [key]: DATA[i].data[key][j]}), {})
        );
        
        vector.push(
          <Tabs.TabPane tab={DATA[i].name} key={DATA[i].name} >
            <Row justify="center" gutter={16}>
              <Col span={24}>
                <TableFullEditable
                  columns={keys}
                  datos={newArray}
                  newdatos={newdatos}
                  setnewdatos={setnewdatos}
                  cambios={cambios}
                  setcambios={setcambios}
                  ></TableFullEditable>
              </Col>
            </Row>
            <p></p>
            <div style={{display:'flex',flexDirection:'Row',justifyContent:'space-between'}}>
           <Button className="boton"
               type="primary"
               style={{borderColor: "red", 
               borderWidth:'2px',
                   fontFamily:'report',
                   color:'red',
                   fontSize:'18px',
                   backgroundColor: "white" }}
                   onClick={async  () => {
                    setCircular(true)
                    await deleteHD(DATA[i].name)
                    setCircular(false)
                   }}>
               Delete data
               <DeleteOutlined />
             </Button>
             <p></p>
             <Button className="boton"
               type="primary"
               style={{borderColor: "rgb(35,148,212)", 
               borderWidth:'2px',
               fontFamily:'report',
                   color:'rgb(0,104,178)',
                   fontSize:'18px',
                   backgroundColor: "white" }}
                   onClick={ async () => {
                     setCircular(true)
                      await saveHistoryData(DATA[i].name)
                      message.success('changes saved')
                     setCircular(false)
                    //  setCircular((prev)=>false)
                    }}>
                 <SaveOutlined />
               Save Data
               
             </Button>
             </div>
             {/* { (circular)
              ?<div style={{display:'flex',justifyContent:'center'}}>
                <div></div>
                <div className="cargandos"></div>
                <div></div>
              </div>
              :<div className="vacio"></div>} */}
          </Tabs.TabPane>
        )
      }
      setdatas(DATA)
      setdataTabla(vector)
    })

  },[setCircular,circular])

  async function saveHistoryData(value){
    // console.log(newdatos)
    var objetoFinal = {};
    setnewdatos(async (prev)=>{
      // console.log('prev: ',prev)
      
      prev.forEach(function(objeto) {
        for (var key in objeto) {
          if (objeto.hasOwnProperty(key)) {
            if (!objetoFinal[key]) {
              objetoFinal[key] = [];
            }
            objetoFinal[key].push(objeto[key]);
          }
        }
      });

      for (var key in objetoFinal) {
        if (objetoFinal.hasOwnProperty(key)) {
          if (key === 'order_id' ||key === 'order_idhub' || key === 'order_items' || key === 'order_bolactivo') {
            objetoFinal[key] = objetoFinal[key].map(Number);
          } else if (key === 'order_lat1' || key === 'order_lon1'|| key === 'order_lat2'|| key === 'order_lon2'|| key === 'order_servicetime1'|| key === 'order_servicetime2'|| key === 'order_weight') {
            objetoFinal[key] = objetoFinal[key].map(parseFloat);
          } else {
            objetoFinal[key] = objetoFinal[key].map(String);
          }
        }
      }
      
      const dat ={
        data: objetoFinal,
        name: value,
      }
      // console.log('edit: ',objetoFinal)
      await post(dat,'save-hd','save-hd','')
      // await saveHD(objetoFinal,value)
      return prev})
      

  }


    return (
      <div>
        <p></p>
        <h1 style={{fontFamily:'report-bold'}} className="titulos">HISTORY DATA SAVED</h1>
          <Tabs defaultActiveKey="1" onChange={() => {}} style={{fontFamily:'report'}}>
          {dataTabla}
        </Tabs>
      </div>
    );
 
}




